import React, { useState, useContext, useEffect } from 'react'
import { Card, CardHeader, CardBody, Nav, NavItem, TabPane, TabContent, NavLink, Row, Col, Input, Label, Form, FormFeedback } from 'reactstrap'
import Header from 'Layout/Header'
import { Container, IconButton } from '@mui/material'
import classnames from "classnames";
import { IMAGES_URL } from 'Utils/URLs';
import { getDisplayUrl } from 'Utils/mediaUrl';
import AuthState from 'Hooks/Authinctication.state';
import PaymentComponent from 'Component/PaymentComponent/PaymentComponent';
import { UserContext } from 'Hooks/UserContext';
import { ToastContainer } from 'react-toastify';
import DriveWithUsState from 'Hooks/DriveWithUs.state';
import { Menu, MenuItem, Typography,Box } from '@mui/material';
import CarRepairIcon from "@mui/icons-material/CarRepair";
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';


const AddAccount = () => {
    const [anchorElNav, setAnchorElNav] = React.useState(false);
    const [activeTab, setActiveTab] = useState("2")
    const [selectedImage, setSelectedImage] = useState({ file: null, preview: null });
    const { UpdateProfile, response, formBusy, GetUserProfile } = AuthState()
    const { GetDriveWithUs, loading, driveWithUsData } = DriveWithUsState()
    const location = useLocation()
    const { tabValue } = location.state || { tabValue: "1" };
    const accountData = sessionStorage.getItem("account")
    const searchParams = new URLSearchParams(location.search);
   
   
    const navigation = useNavigate()
    function isExpired(dateString) {
        const givenDate = new Date(dateString);
        const currentDate = new Date();

        return givenDate < currentDate;
    }
    useEffect(() => {
        GetDriveWithUs(user?.token)
    }, [])
    const { user, value, setValue } = useContext(UserContext)
    const onFileChange = (e) => {
        setSelectedImage({
            file: e.target.files[0],
            preview: URL.createObjectURL(e.target.files[0])
        });
    }

    useEffect(() => {
        if (tabValue) {
            setActiveTab(tabValue)
        }
    }, [tabValue])
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    const tabChange = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

   

    const mobileTabs = [
        {
            value: "one",
            label: "Profile",
            icon: <i className="las la-user" />,
            condition: true,
        },
        {
            value: "three",
            label: "Drive With Us",
            icon: <i className="las la-car" />,
            condition:
                user?.form_name === "drive_with_us" &&
                driveWithUsData.some(
                    (item) => isExpired(item.file_expiry) || item.file_status === 2
                ),
        },
        {
            value: "three",
            label: "Partner With Us",
            icon: <i className="mdi mdi-handshake-outline" />,
            condition:
                user?.form_name === "partner_with_us"
        },
        {
            value: "three",
            label: "Get Free Ride",
            icon: <i className="mdi mdi-taxi" />,
            condition:
                user?.form_name === "free_ride"
        },
        {
            value: "two",
            label: "Account",
            icon: <i className="ri-bank-line -mt-5" />,
            condition: user?.status === "1",
        },
        {
            value: "four",
            label: "Update Car Information",
            icon: <CarRepairIcon />,
            condition: user?.form_name === "drive_with_us" && driveWithUsData.length > 0,
        },
    ]

    return (
        <Box className='edit-profile' sx={{background:{xs:"linear-gradient(180deg,rgba(151, 193, 31, 1) 26%, rgba(233, 255, 166, 1) 67%, rgba(255, 255, 255, 1) 94%)",md:"#FFF"}}} >
            <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                PaperProps={{
                    sx: {
                        mt: 6.5,
                        backgroundColor: '#021B38', // deep blue
                        color: '#96c11e',
                        borderRadius: 2,
                        boxShadow: 3,
                        minWidth: 200,
                        '& .MuiMenuItem-root': {
                            gap: 1,
                            paddingY: 1,
                            paddingX: 2,
                            '&:hover': {
                                backgroundColor: '#021B48',
                            },
                        },
                        '& .MuiSvgIcon-root': {
                            color: '#96c11e',
                        },
                    },
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {mobileTabs.map((tab) => (
                    tab.condition && (
                        <MenuItem key={tab.value} onClick={() => { setValue(tab.value); handleCloseNavMenu() }}>
                            {tab.icon}
                            <Typography>{tab.label}</Typography>
                        </MenuItem>
                    )
                ))}


            </Menu>
            <ToastContainer />
            <div className="cover-image m-2 m-md-5 pb-5  " style={{ borderRadius: 10 }} >
                <Header setValue={setValue} />
                <Container sx={{ pt: { xs: 1, md: 4 } }} >

                </Container>
            </div>
            <Container>

                <Row>
                    <Col xxl={3} md={6} >
                        <Card className=" mt-n5">
                            <IconButton onClick={() => {navigation("/driver_forms/profile");setValue(1)}} sx={{ backgroundColor: "#92c323", m: 2, px: 3, color: "#FFF",width:"fit-content", borderRadius: 2, '&:hover': { backgroundColor: "#76a521" } }} variant="contained" size="icon" className="d-flex d-md-none"   >
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </IconButton>
                            <CardBody className="p-4">
                                <div className="text-center">
                                    <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
                                        <img src={user?.profile_pic ? getDisplayUrl(user.profile_pic, IMAGES_URL) : selectedImage.preview ? selectedImage.preview : "/driver_forms/assets/images/user-dummy-img.jpg"}
                                            className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                                            alt="user-profile" />
                                        <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                                            <Input onChange={onFileChange} id="profile-img-file-input" type="file"
                                                className="profile-img-file-input" />
                                            <Label htmlFor="profile-img-file-input"
                                                className="profile-photo-edit avatar-xs">
                                                <span className="avatar-title rounded-circle bg-light text-body">
                                                    <i className="ri-camera-fill"></i>
                                                </span>
                                            </Label>
                                        </div>
                                    </div>
                                    <h5 className="fs-17 mb-1 edit-title ">{user?.first_name} {user?.last_name} </h5>
                                    <p className="text-muted mb-2 edit-desc " >{user?.email}</p>
                                </div>
                            </CardBody>
                        </Card>


                    </Col>
                    <Col xxl={9} md={6} >
                        <Card className="mt-n5" >
                            <CardHeader style={{ backgroundColor: "#FFF" }}  >
                                <Nav className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                                    role="tablist">
                                       
                                  
                                        <NavItem >
                                            <NavLink to="#"
                                                className={classnames({ active: activeTab === "0" })}
                                                onClick={() => {
                                                    tabChange("2");
                                                }}
                                                type="button">
                                                <i className="far fa-envelope"></i>
                                                Account
                                            </NavLink>
                                        </NavItem>
                                   


                                </Nav>
                            </CardHeader>
                            <CardBody>
                                <TabContent activeTab={activeTab}>
                                   
                                    <TabPane tabId="2">
                                        <PaymentComponent />
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Col>

                </Row>
            </Container>
        </Box>
    )
}

export default AddAccount